/**
 * Підпис запису в полі-посиланні (UIUX/field-types/lookup; прототип v4 ref-пікер «101 · Назва»): «номер · назва» — номер без префікса типу
 * (recordNumber); без назви — лише номер.
 */
export function recordOptionLabel(number: string, title: string | null | undefined): string {
  const t = (title ?? '').trim();
  return t ? `${number} · ${t}` : number;
}
